import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=94dbd7f0&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=94dbd7f0&prod&lang=scss&scoped=true"
import style1 from "./PaymentForm.vue?vue&type=style&index=1&id=94dbd7f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dbd7f0",
  null
  
)

export default component.exports